export const AP_KNOWLEDGE_CENTER_LOADER = {
  desktop: `<div class="cui cui-grid cui-container">
  <div class="cui-skeleton-heading -size--large -spacing--top-64 -spacing--bottom-20 -resolution--desktop">
    <div class="cui-skeleton-heading__content" style="width: max(300px, 100%);">
      <div class="cui-skeleton__item cui-skeleton-heading__title"></div>
      <div class="cui-skeleton__item cui-skeleton__description"></div>
    </div>
  </div>
  <div class="cui-skeleton-heading -size--medium -spacing--top-40 -spacing--bottom-40 -resolution--desktop">
    <div class="cui-skeleton-heading__content" style="width: max(300px, 100%);">
      <div class="cui-skeleton__item cui-skeleton-heading__title"></div>
    </div>
  </div>
  <div class="cui-grid">
    <div class="cui-row">
      <div class="cui-col-lg-4">
        <div class="cui-skeleton-rectangle -is--block">
          <div class="cui-skeleton__item" style="width: 100%; height: 390px;"></div>
        </div>
      </div>
      <div class="cui-col-lg-4">
        <div class="cui-skeleton-heading -size--medium -resolution--desktop">
          <div class="cui-skeleton-rectangle -is--block">
            <div class="cui-skeleton__item" style="width: 100%; height: 390px;"></div>
          </div>
        </div>
      </div>
      <div class="cui-col-lg-4">
        <div class="cui-skeleton-rectangle -is--block">
          <div class="cui-skeleton__item" style="width: 100%; height: 390px;"></div>
        </div>
      </div>
      <div class="cui-col-lg-4">
        <div class="cui-skeleton-rectangle -is--block">
          <div class="cui-skeleton__item" style="width: 100%; height: 390px;"></div>
        </div>
      </div>
      <div class="cui-col-lg-4">
        <div class="cui-skeleton-rectangle -is--block">
          <div class="cui-skeleton__item" style="width: 100%; height: 390px;"></div>
        </div>
      </div>
      <div class="cui-col-lg-4">
        <div class="cui-skeleton-rectangle -is--block">
          <div class="cui-skeleton__item" style="width: 100%; height: 390px;"></div>
        </div>
      </div>
      <div class="cui-col-lg-4">
        <div class="cui-skeleton-rectangle -is--block">
          <div class="cui-skeleton__item" style="width: 100%; height: 390px;"></div>
        </div>
      </div>
      <div class="cui-col-lg-4">
        <div class="cui-skeleton-rectangle -is--block">
          <div class="cui-skeleton__item" style="width: 100%; height: 390px;"></div>
        </div>
      </div>
      <div class="cui-col-lg-4">
        <div class="cui-skeleton-rectangle -is--block">
          <div class="cui-skeleton__item" style="width: 100%; height: 390px;"></div>
        </div>
      </div>
    </div>
    <div>
      <div class="cui-skeleton-rectangle -is--block -spacing--top-40">
          <div class="cui-skeleton__item" style="width: 10%; height: 40px; margin-left: 45%;"></div>
      </div>
    </div>
  </div>
</div>`
};
